import React from 'react';
import Hero from "./components/nep-syllabus/Hero";
import Main from "./components/nep-syllabus/Main";

const NepSyllabus = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default NepSyllabus;